export default __webpack_public_path__ + "static/media/GMATS.e57f936e.png";